module.exports = __webpack_public_path__ + "img/img_trenner.4c286d56.png";